export class AcctactvtyTracker {
  public errors: null[] | null;
  public currentYearCardSpend: CurrentYear;
  public currentYearMQD: CurrentYear;
  public currentYearMQM: CurrentYear;
  public currentYearMQS: CurrentYear;
  public currentProgramYear: string;
  public lifetimeMQM: string;
  public currentYearTierCode: string;
  public currentYearTierDesc: string;
  public enrolledForCoBrandCard: boolean;
  public futureProgramYear: string;
  public nextProgramYear: string;
  public futureYearTierCode: string;
  public futureYearTierDesc: string;
  public internationalCustomer: boolean;
  public satisfiedCurrYearMileageCriteria: boolean;
  public satisfiedCurrYearSpendCriteria: boolean;
  public satisfiedPrevYearMileageCriteria: boolean;
  public satisfiedPrevYearSpendCriteria: boolean;
  public showNewMQDWaiverCopy: string;
  public spendReqApplicableForCurrentYear: boolean;
  public spendReqApplicableForPrevYear: boolean;
  public trackingTowardsTierCode: string;
  public trackingTowardsTierDesc: string;
  public transactionId: string;
  public partnerAnnualCobrands: null[] | null;
  public rolloverMQM: null[] | null;
  public tierLevelInfos: null[] | null;
  public corporateAgreementInfos: null[] | null;

  public constructor(acctactvtyTracker: any) {
    this.errors = acctactvtyTracker.errors;
    this.currentYearCardSpend = acctactvtyTracker.currentYearCardSpend;
    this.currentYearMQD = acctactvtyTracker.currentYearMQD;
    this.currentYearMQM = acctactvtyTracker.currentYearMQM;
    this.currentYearMQS = acctactvtyTracker.currentYearMQS;
    this.currentProgramYear = acctactvtyTracker.currentProgramYear;
    this.lifetimeMQM = acctactvtyTracker.lifetimeMQM;
    this.currentYearTierCode = acctactvtyTracker.currentYearTierCode;
    this.currentYearTierDesc = acctactvtyTracker.currentYearTierDesc;
    this.enrolledForCoBrandCard = acctactvtyTracker.enrolledForCoBrandCard;
    this.futureProgramYear = acctactvtyTracker.futureProgramYear;
    this.nextProgramYear = acctactvtyTracker.nextProgramYear;
    this.futureYearTierCode = acctactvtyTracker.futureYearTierCode;
    this.futureYearTierDesc = acctactvtyTracker.futureYearTierDesc;
    this.internationalCustomer = acctactvtyTracker.internationalCustomer;
    this.satisfiedCurrYearMileageCriteria =
      acctactvtyTracker.satisfiedCurrYearMileageCriteria;
    this.satisfiedCurrYearSpendCriteria =
      acctactvtyTracker.satisfiedCurrYearSpendCriteria;
    this.satisfiedPrevYearMileageCriteria =
      acctactvtyTracker.satisfiedPrevYearMileageCriteria;
    this.satisfiedPrevYearSpendCriteria =
      acctactvtyTracker.satisfiedPrevYearSpendCriteria;
    this.showNewMQDWaiverCopy = acctactvtyTracker.showNewMQDWaiverCopy;
    this.spendReqApplicableForCurrentYear =
      acctactvtyTracker.spendReqApplicableForCurrentYear;
    this.spendReqApplicableForPrevYear =
      acctactvtyTracker.spendReqApplicableForPrevYear;
    this.trackingTowardsTierCode = acctactvtyTracker.trackingTowardsTierCode;
    this.trackingTowardsTierDesc = acctactvtyTracker.trackingTowardsTierDesc;
    this.transactionId = acctactvtyTracker.transactionId;
    this.partnerAnnualCobrands = acctactvtyTracker.partnerAnnualCobrands;
    this.rolloverMQM = acctactvtyTracker.rolloverMQM;
    this.tierLevelInfos = acctactvtyTracker.tierLevelInfos;
    this.corporateAgreementInfos = acctactvtyTracker.corporateAgreementInfos;
  }
}

export class CurrentYear {
  public availableBalance: string;
  public maxForCurrentTier: string;
  public minForCurrentTier: string;
  public neededForNextTier: string;
  public percentTowardsHighestTier: string;
  public percentTowardsNextTier: string;

  public constructor(currentYear: any) {
    this.availableBalance = currentYear.availableBalance;
    this.maxForCurrentTier = currentYear.maxForCurrentTier;
    this.minForCurrentTier = currentYear.minForCurrentTier;
    this.neededForNextTier = currentYear.neededForNextTier;
    this.percentTowardsHighestTier = currentYear.percentTowardsHighestTier;
    this.percentTowardsNextTier = currentYear.percentTowardsNextTier;
  }
}
